module.exports = __webpack_public_path__ + "9788f41e/img/settings-icon.121d9519.svg";